import React from "react";
import { DataTable, Surface, Text } from "react-native-paper";

interface DailyEarningsExpensesTableProps {
  weekDates: Date[];
  dailyEarnings: Record<string, number>;
  dailyExpenses: Record<string, number>;
}

export const DailyEarningsExpensesTable: React.FC<
  DailyEarningsExpensesTableProps
> = ({ weekDates, dailyEarnings, dailyExpenses }) => {
  return (
    <Surface style={{ marginTop: 24, borderRadius: 8 }} elevation={1}>
      <Text variant="titleMedium" style={{ padding: 16, paddingBottom: 8 }}>
        Доходы и расходы
      </Text>
      <DataTable>
        <DataTable.Header>
          <DataTable.Title style={{ flex: 0.4 }}>Дата</DataTable.Title>
          <DataTable.Title numeric>Доход</DataTable.Title>
          <DataTable.Title numeric>Расход</DataTable.Title>
          <DataTable.Title numeric>Профит</DataTable.Title>
        </DataTable.Header>
        {weekDates.map((date) => {
          const dateStr = date.toLocaleDateString("ru-RU");
          const earnings = dailyEarnings[dateStr] || 0;
          const expenses = dailyExpenses[dateStr] || 0;
          const profit = earnings - expenses;
          return (
            <DataTable.Row key={dateStr}>
              <DataTable.Cell style={{ flex: 0.4 }}>{dateStr}</DataTable.Cell>
              <DataTable.Cell numeric>
                {earnings > 0 ? earnings.toLocaleString("ru-RU") : "-"}
              </DataTable.Cell>
              <DataTable.Cell numeric>
                {expenses > 0 ? expenses.toLocaleString("ru-RU") : "-"}
              </DataTable.Cell>
              <DataTable.Cell numeric>
                {profit !== 0 ? profit.toLocaleString("ru-RU") : "-"}
              </DataTable.Cell>
            </DataTable.Row>
          );
        })}
        {/* Итоговая строка за неделю */}
        <DataTable.Row>
          <DataTable.Cell style={{ flex: 0.4 }}>Итог</DataTable.Cell>
          <DataTable.Cell numeric>
            {Object.values(dailyEarnings)
              .reduce((sum, v) => sum + v, 0)
              .toLocaleString("ru-RU")}
          </DataTable.Cell>
          <DataTable.Cell numeric>
            {Object.values(dailyExpenses)
              .reduce((sum, v) => sum + v, 0)
              .toLocaleString("ru-RU")}
          </DataTable.Cell>
          <DataTable.Cell numeric>
            {(
              Object.values(dailyEarnings).reduce((sum, v) => sum + v, 0) -
              Object.values(dailyExpenses).reduce((sum, v) => sum + v, 0)
            ).toLocaleString("ru-RU")}
          </DataTable.Cell>
        </DataTable.Row>
      </DataTable>
    </Surface>
  );
};
